import { OffsetPageParams } from "@safetyculture/s12-apis-connect-web/s12/common/v1/page_offset_pb";
import {
  ListHardwareSensorsRequest,
  ListHardwareSensorsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/iot/admin/v1/sensors_pb";
import {
  DownloadSensorAlertsRequest,
  DownloadSensorAlertsResponse,
  ListArchivedSensorsRequest,
  ListArchivedSensorsResponse,
  ListGatewaysForOrgRequest,
  ListGatewaysForOrgResponse,
  SensorType,
} from "@safetyculture/s12-apis-connect-web/s12/sensors/admin/v1/sensors_pb";
import { GetHardwareSensorDetailsResponse } from "@safetyculture/s12-apis-connect-web/s12/sensors/v1/sensors_pb";
import { GetHardwareSensorDetailsRequest } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/sensors_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";
import { toUUID } from "helpers/s12-helpers";
import { convertToTimestamp } from "helpers/time";

type ListHardwareSensorsForOrgParams = {
  orgId: string;
};

export const listHardwareSensorsForOrg = async (
  { orgId }: ListHardwareSensorsForOrgParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListHardwareSensorsResponse> => {
  const req = new ListHardwareSensorsRequest({
    orgId: orgId,
  });

  return supportServiceConnectClient.listHardwareSensorsForOrg(req, {
    headers,
  });
};

type ListArchivedSensorsForOrgParams = {
  orgId: string;
  page?: OffsetPageParams;
  query?: string;
  sensorType?: SensorType;
};

export const listArchivedSensorsForOrg = async (
  { orgId, page, query, sensorType }: ListArchivedSensorsForOrgParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListArchivedSensorsResponse> => {
  const req = new ListArchivedSensorsRequest({
    organizationId: toUUID(orgId),
    page: page,
    query: query,
    sensorType: sensorType,
  });

  return supportServiceConnectClient.listArchivedSensorsForOrg(req, {
    headers,
  });
};

type ListGatewaysForOrgParams = {
  orgId: string;
};

export const listGatewaysForOrg = async (
  { orgId }: ListGatewaysForOrgParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListGatewaysForOrgResponse> => {
  const req = new ListGatewaysForOrgRequest({
    organizationId: toUUID(orgId),
  });

  return supportServiceConnectClient.listGatewaysForOrg(req, {
    headers,
  });
};

type DownloadSensorAlertHistoryForOrgParams = {
  orgId: string;
  fromDate: Date;
  toDate: Date;
};

export const downloadSensorAlertHistoryForOrg = async (
  { orgId, fromDate, toDate }: DownloadSensorAlertHistoryForOrgParams,
  headers: Record<RequestMetadata, string>,
): Promise<string> => {
  const req = new DownloadSensorAlertsRequest({
    organizationId: orgId,
    startTime: convertToTimestamp(fromDate),
    endTime: convertToTimestamp(toDate),
  });

  return supportServiceConnectClient
    .downloadSensorAlertHistory(req, {
      headers,
    })
    .then((res: DownloadSensorAlertsResponse) => res.url);
};

type GetHardwareSensorDetailsParams = {
  sourceName: string;
  sourceId: string;
  orgId: string;
};

export const getHardwareSensorDetails = async (
  { sourceName, sourceId, orgId }: GetHardwareSensorDetailsParams,
  headers: Record<RequestMetadata, string>,
): Promise<GetHardwareSensorDetailsResponse> => {
  const req = new GetHardwareSensorDetailsRequest({
    source: sourceName,
    id: sourceId,
    orgId: toUUID(orgId),
  });

  return supportServiceConnectClient.getHardwareSensorDetails(req, {
    headers,
  });
};
